import { styled } from '@mui/material/styles';
import { alpha, Button } from '@mui/material';
import { grey } from '@mui/material/colors';

export const DropZoneContainer = styled(Button, { name: 'DropZoneContainer' })(({ theme }) => ({
	border: `${theme.spacing(0.5)} dashed ${theme.palette.primary.main}`,
	boxShadow: 'inset 0 0 20px rgba(0, 0, 0, 0.3)',
	backgroundColor: alpha(grey[500], 0.7),
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	cursor: 'pointer',
	boxSizing: 'border-box',
	textTransform: 'none',
	gap: theme.spacing(2),
	'&:hover': {
		borderWidth: '2px',
		backgroundColor: alpha(grey[300], 0.7),
	},
	'&.Mui-disabled': {
		color: theme.palette.primary.main,
		opacity: 1,
		borderWidth: '2px',
		backgroundColor: alpha(grey[500], 0.7),
		borderColor: theme.palette.primary.main,
	},
}));

const fontSizes = {
	small: '12px',
	medium: '18px',
	large: '24px',
};

export const DropZoneText = styled('span', {
	name: 'DropZoneText',
	shouldForwardProp: (prop) => !['size'].includes(prop as string),
})<{ size: 'small' | 'medium' | 'large' }>(({ size }) => ({
	fontSize: fontSizes[size],
	fontWeight: 'bold',
}));
